<template>
  <el-tooltip placement="left">
    <div slot="content" class="data-table-th-listname-list">
      <span
        v-for="report_in in report_in"
        class="pointer"
        v-show="report_in.report_id != report_id"
        :key="report_in.report_id"
        style="margin-right:5px"
        @click.exact="openReport(report_in.report_id)"
      >
        <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
        {{ report_in.report_name }}
        <br /> </span
      >に追加されています
    </div>
    <span>
      <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
      {{ report_count }}件のレポート
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: "reportIn",
  props: ["report_in", "report_count"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    openReport(id) {
      let routeData = this.$router.resolve({
        name: "reportDetail",
        params: {
          report_id: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
